import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { PropType } from 'vue';
import { ref, toRefs } from 'vue';

// PERSONAL COMPONENTS
import QBtnValid from '@components/form/QBtnValid.vue';
import QVideoCustom from '@components/QVideoCustom.vue';
import QDialogTemplate from '@components/template/QDialogTemplate.vue';

// ViewModel
import { useGlobalVM } from '@viewmodel/global.vm';

// PERSONAL LIBS
import { IVideo } from '@shared/interface/model.interface';
import { DialogSizeEnum } from '@shared/enum/dialog-size.enum';

/**
 * Events
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'DialogVideoView',
  props: {
  show: { type: Boolean, required: true, default: false },
  video: { type: Object as PropType<IVideo | undefined>, required: true },
  programLabel: { type: String, required: true },
},
  emits: ['close', 'success', 'failed'],
  setup(__props, { emit: __emit }) {

// VENDOR
const emits = __emit;

/**
 * Viewmodel
 */
const { isMobile } = useGlobalVM();

/**
 * Reactive datas
 */
const loading = ref<boolean>(false);
const msgError = ref<string | undefined>();

/**
 * Properties
 */
const props = __props;
const { show, video, programLabel } = toRefs(props);

/**
 * Methods
 */
function onClose() {
  emits('close');
}

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!

  return (_openBlock(), _createBlock(QDialogTemplate, {
    "show-dialog": _unref(show),
    title: `Vidéo (${_unref(programLabel).toUpperCase()})`,
    maximized: _unref(isMobile),
    persistent: loading.value,
    "dialog-size": _unref(DialogSizeEnum).LARGE,
    onClose: _cache[3] || (_cache[3] = ($event: any) => (onClose()))
  }, {
    content: _withCtx(() => [
      _createVNode(_component_q_card, {
        flat: "",
        class: "no-border-radius q-pa-none q-ma-none"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "text-center q-pa-xs q-ma-xs" }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(QVideoCustom, {
                video: _unref(video),
                "program-label": _unref(programLabel),
                onLoaded: _cache[0] || (_cache[0] = ($event: any) => (loading.value = false)),
                onLoading: _cache[1] || (_cache[1] = ($event: any) => (loading.value = true)),
                onClose: onClose
              }, null, 8 /* PROPS */, ["video", "program-label"]), [
                [_vShow, _unref(show)]
              ]),
              _createVNode(_Transition, {
                appear: "",
                "enter-active-class": "animated fadeIn",
                "leave-active-class": "animated fadeOut",
                persisted: ""
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", null, _toDisplayString(msgError.value), 513 /* TEXT, NEED_PATCH */), [
                    [_vShow, msgError.value != null]
                  ])
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_q_card, {
        flat: "",
        class: "no-border-radius"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_separator),
          _createVNode(_component_q_card_actions, { align: "right" }, {
            default: _withCtx(() => [
              _createVNode(QBtnValid, {
                label: 'Fermer',
                onClick: _cache[2] || (_cache[2] = ($event: any) => (onClose())),
                disable: loading.value
              }, null, 8 /* PROPS */, ["disable"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show-dialog", "title", "maximized", "persistent", "dialog-size"]))
}
}

})